import {
  Checkbox,
  createTheme,
  Input,
  Modal,
  Popover,
  Text,
  Tooltip,
} from '@mantine/core';
import { Notifications } from '@mantine/notifications';

/** Mantine 9 labels use var(--mantine-font-weight-medium) (600); portal uses 400. */
const fieldLabelStyles = {
  '--mantine-font-weight-medium': '400',
  fontWeight: 'normal',
  fontFamily: 'var(--portal-ui-font-family, inherit)',
  lineHeight: 1.1875,
} as const;

/** Mantine 9 Input.Wrapper root uses --mantine-line-height (1.55); portal labels use 1.1875em. */
const inputWrapperRootStyles = {
  lineHeight: 1.1875,
  // Mantine 9 ::placeholder uses --input-placeholder-color (defaults to mantine-color-placeholder).
  '--input-placeholder-color': 'rgb(var(--portal-ui-color-placeholder))',
} as const;

/** Portal placeholders use --portal-ui-color-placeholder (see input.module.scss). */
const inputPlaceholderStyles = {
  color: 'rgb(var(--portal-ui-color-placeholder))',
} as const;

/** Mantine 9 defaults error text to font-size-xs; portal uses 14px (see ErrorMessage). */
const fieldErrorStyles = {
  fontSize: '0.875rem',
  lineHeight: 1,
  fontFamily: 'var(--portal-ui-font-family, inherit)',
  color: 'rgb(var(--portal-ui-color-error))',
} as const;

/**
 * Mantine 8+ enables hideDetached on Popover by default, which closes dropdowns
 * when the target is scrolled out of view or considered detached (including in tests).
 */
export const portalMantineTheme = createTheme({
  defaultRadius: 'sm',
  components: {
    'Input.Wrapper': Input.Wrapper.extend({
      styles: {
        root: inputWrapperRootStyles,
        label: fieldLabelStyles,
        error: fieldErrorStyles,
      },
    }),
    'Input.Placeholder': Input.Placeholder.extend({
      styles: {
        placeholder: inputPlaceholderStyles,
      },
    }),
    Checkbox: Checkbox.extend({
      styles: {
        label: fieldLabelStyles,
      },
    }),
    Text: Text.extend({
      // Mantine 9 defaults to font-size-md; portal Text should match parent (14px body).
      defaultProps: {
        inherit: true,
      },
    }),
    Modal: Modal.extend({
      defaultProps: {
        overlayProps: {
          backgroundOpacity: 0,
          blur: 3,
        },
      },
    }),
    Popover: Popover.extend({
      defaultProps: {
        hideDetached: false,
      },
    }),
    Tooltip: Tooltip.extend({
      vars: () => ({
        tooltip: {
          '--tooltip-bg': 'rgb(var(--portal-ui-color-grey-2))',
          '--tooltip-color': 'rgb(var(--portal-ui-color-text))',
        },
      }),
    }),
    Notifications: Notifications.extend({
      defaultProps: {
        pauseResetOnHover: 'notification',
      },
    }),
  },
});
